angular.module('gym.users').controller('ManageMfaPolicyModalController', ["$scope", "$rootScope", "$modalInstance", "$http", "$window", function($scope, $rootScope, $modalInstance, $http, $window) {
  $scope.gym = $rootScope.gym;
  $scope.params = {
    multi_factor_auth_enabled_default: $scope.gym.multi_factor_auth_enabled_default,
    multi_factor_auth_required_default: $scope.gym.multi_factor_auth_required_default
  };
  $scope.submit = function() {
    var url;
    $scope.isLoading = true;
    url = `/gyms/${$scope.gym.id}/update_multi_factor_settings`;
    return $http.put(url, {
      gym: $scope.params
    }).then(function() {
      return $window.location.reload();
    }, function() {
      return $scope.isLoading = false;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
